import { render } from "react-dom";
import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import { withRouter } from 'react-router';
import SelectSearchField from '../forms/SelectSearchField';


class ViewAsStudent extends Component {

    static displayName = ViewAsStudent.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            studentId: false,
            filterText : ""
        };

        this.props.store.updateBanner("View As Student");

        this.handleSubmission = this.handleSubmission.bind(this);
        this.studentSearch = this.studentSearch.bind(this);

    }


    async handleSubmission(event) {
        await this.props.store.changeView(event.studentId)

        this.setState({ studentId: event.studentId })

        this.props.history.push("/");
    }

    studentSearch() {
        let students = this.props.store.students.collection;
        students.sort(this.props.store.students.sortByLastName);

        const options = students.map(student => {
            return {
                label: student.name,
                value: student.id
            }
        });


        return (
            <div className="col-12 col-md-6">
                <Formik
                    initialValues={{ studentId: "0" }}
                    onSubmit={async (values, { setSubmitting }) => await this.handleSubmission(values, setSubmitting)}
                >
                    <Form>
                        <label for="studentId">Select Student</label>
                        <Field component={SelectSearchField} name="studentId" options={options} isClearable={true} />
                        
                        <button className="btn btn-primary" type="submit">
                            Select Student
                        </button>
                    </Form>
                </Formik>
            </div>
        )
    }

    render() {
        return (
            <div>
                {this.studentSearch()}
            </div>
        );
    }
}

export default withRouter(ViewAsStudent);